import React, { Component } from 'react'
import classnames from 'classnames'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Button, Form, Select, Input, DatePicker } from 'antd'
import SelectTenant from '@/components/SelectTenant'
import SelectUser from '@/components/SelectUser'
import SelectOrder from '@/components/SelectOrder'
import styles from './fundFlows.module.scss'
import { flowTypes } from '../constants'
import FilterItem from '@/components/FilterItem'

const { RangePicker } = DatePicker;
const flowTypeKeys = Object.keys(flowTypes)
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
}

@connect()
@Form.create()
export default class Filters extends Component {
  normalizeTenant = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value
    }

    if (value && value._id) {
      return value._id
    }

    return null
  }

  normalizeOrder = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value
    }

    if (value && value._id) {
      return value._id
    }

    return null
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      if (values.time_range && values.time_range[0] && values.time_range[1]) {
        values.time_range = [
          values.time_range[0].startOf('day').valueOf(),
          values.time_range[1].endOf('day').valueOf()
        ]
      }

      values = _.pickBy(values, _.identity)

      this.props.onChange(values)
    })
  }

  render() {
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form

    return (
      <Form onSubmit={this.handleSubmit} layout="inline">
        <div className={styles.filters}>
          <FilterItem
            className={styles.row}
            {...formItemLayout}
            label="交易类型">
            {getFieldDecorator('type')(
              <Select placeholder="请选择交易类型" style={{ width: 180 }} >
                <Select.Option value={null}>全部</Select.Option>
                {
                  flowTypeKeys.map(key => (
                    <Select.Option key={key} value={key}>{flowTypes[key]}</Select.Option>
                  ))
                }
              </Select>
            )}
          </FilterItem>
          <FilterItem
            className={styles.row}
            {...formItemLayout}
            label="收支类型">
            {getFieldDecorator('flow_type')(
              <Select placeholder="请选择交易类型" style={{ width: 180 }} >
                <Select.Option value="income">收入</Select.Option>
                <Select.Option value="expense">支出</Select.Option>
              </Select>
            )}
          </FilterItem>

          <FilterItem
            className={styles.row}
            {...formItemLayout}
            label="日期范围">
            {getFieldDecorator('time_range')(
              <RangePicker style={{ width: 240 }} />
            )}
          </FilterItem>
          <FilterItem
            className={styles.row}
            {...formItemLayout}>
            <div className={styles.submitBtns}>
              <Button type="primary" htmlType="submit">查询</Button>
              {/* <Button type="default" style={{ marginLeft: 8 }} htmlType="reset">重置</Button> */}
            </div>
          </FilterItem>
        </div>
      </Form>
    )
  }
}
